"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/ExpandingInput.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _string = require('shared/services/string');





var _composer = require('shared/services/composer');
var _EmojiPicker = require('./EmojiPicker'); var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);
var _Tooltip = require('../Tooltip');
var _ComposerActionMenu = require('./ComposerActionMenu'); var _ComposerActionMenu2 = _interopRequireDefault(_ComposerActionMenu);
var _ComposerSendButton = require('./ComposerSendButton'); var _ComposerSendButton2 = _interopRequireDefault(_ComposerSendButton);


var _mentions = require('shared/services/mentions');


const containerStyle = { pointerEvents: "none", opacity: "0.4" }
const noop = () => undefined
const EMPTY_CANDIDATES = []
const EMPTY_MENTIONS = []
const NO_HANDLERS = {}
const NO_CHIPS = []

const composerPlatform = () =>
  typeof window !== 'undefined' && window.ELECTRON ? 'desktop' : 'web'
const isMac = () => typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform || '')

const processEmojis = (text) => {
  const reg = /:(\S+?):/g
  const matches = text.match(reg)
  if (!matches) return text

  let newText = text
  matches.forEach(match => {
    const query = match.split(':')[1]
    if (!query) return
    const emoji = _EmojiPicker.lookupEmoji.call(void 0, query)
    if (!emoji) return
    newText = text.replace(match, emoji)
  })

  return newText
}

// The web composer's handle for the modules that plug into it.





























































// The distinct lines an inline element's text sits on.
const lineCount = (node) => new Set(Array.from(node.getClientRects(), rect => Math.round(rect.top))).size

const prefersReducedMotion = () => typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches

// The composer's own surfaces: its card, and what it opens outside the card
// (the Send later panel), which carries data-composer-part.
const isComposerPart = (node, card) =>
  node instanceof Element && (!!_optionalChain([card, 'optionalAccess', _ => _.contains, 'call', _2 => _2(node)]) || !!node.closest('[data-composer-part]'))

// What moves when the layout switches, and the point of it that is tracked:
// + and Send ▾ (and the counter) keep their size and move by their centres.
// The text keeps its place in its layer while the layer's padding changes, so
// the drawn text is tracked by where it starts (the mirror's text), and the
// textarea's caret text by its padding corner.

const MOVING_PARTS = [
  { selector: '.chat--createMessageBox--inputarea--plus', anchor: 'centre' },
  { selector: '.composer-send', anchor: 'centre' },
  { selector: '.composer--counter', anchor: 'centre' },
  { selector: '.chat--createMessageBox--mirror-container', anchor: 'text' },
  { selector: '.chat--createMessageBox--input', anchor: 'padding' },
]







const anchorPoint = (node, anchor) => {
  if (anchor === 'text') {
    const text = _optionalChain([node, 'access', _3 => _3.querySelector, 'call', _4 => _4('.chat--createMessageBox--mirror'), 'optionalAccess', _5 => _5.getClientRects, 'call', _6 => _6(), 'access', _7 => _7[0]])
    if (text) return { x: text.left, y: text.top }
  }
  const rect = node.getBoundingClientRect()
  if (anchor === 'centre') return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 }
  const style = getComputedStyle(node)
  return { x: rect.left + parseFloat(style.paddingLeft || '0'), y: rect.top + parseFloat(style.paddingTop || '0') }
}

const measureCard = (card) => {
  const box = card.getBoundingClientRect()
  return {
    height: box.height,
    parts: MOVING_PARTS.map(({ selector, anchor }) => {
      const node = card.querySelector(selector)
      if (!node) return null
      const point = anchorPoint(node, anchor)
      return { x: point.x - box.left, y: point.y - box.bottom }
    }),
  }
}

// Ease-out: fastest at the start, but not front-loaded enough to jump.
const SWITCH_TIMING = { duration: 200, easing: 'ease-out' }










const MentionPickerRow = _react.memo.call(void 0, ({ candidate, index, query, selected, onPick, onHover }) => {
  const onMouseDown = _react.useCallback.call(void 0, (event) => {
    event.preventDefault()
    onPick(candidate)
  }, [onPick, candidate])
  const onMouseEnter = _react.useCallback.call(void 0, () => onHover(index), [onHover, index])

  const lowerQuery = query.toLocaleLowerCase()
  const name = candidate.DisplayName
  const match = lowerQuery ? name.toLocaleLowerCase().indexOf(lowerQuery) : -1
  const nameNode = match >= 0
    ? _react2.default.createElement(_react2.default.Fragment, null, name.slice(0, match), _react2.default.createElement('mark', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}, name.slice(match, match + lowerQuery.length)), name.slice(match + lowerQuery.length))
    : name
  const initials = name.split(/\s+/u).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase() || '@'
  const avatar = candidate.Kind === 'team'
    ? _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}, "group")
    : candidate.Kind === 'all'
      ? '@'
      : initials
  // The @all keyword keeps its @ (it is literally what gets inserted);
  // people and teams read as plain names.
  const label = candidate.Kind === 'all' ? _react2.default.createElement(_react2.default.Fragment, null, "@", nameNode) : nameNode
  const tint = candidate.Kind === 'user' || candidate.Kind === 'patient'
    ? _mentions.mentionAvatarTint.call(void 0, candidate.TargetKey || name)
    : undefined

  return (
    _react2.default.createElement('div', {
      role: "option",
      tabIndex: -1,
      'aria-selected': selected,
      className: _classBuilder2.default.call(void 0, 'chat--mention-picker--row', selected && 'chat--mention-picker--selected'),
      onMouseDown: onMouseDown,
      onMouseEnter: onMouseEnter, __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}}

      , _react2.default.createElement('span', {
        className: _classBuilder2.default.call(void 0, 'chat--mention-picker--avatar', (candidate.Kind === 'team' || candidate.Kind === 'all') && 'chat--mention-picker--avatar-team'),
        style: tint,
        'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 212}}
, avatar)
      , _react2.default.createElement('span', { className: "chat--mention-picker--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}, label)
      , candidate.Secondary && _react2.default.createElement('span', { className: "chat--mention-picker--secondary", __self: this, __source: {fileName: _jsxFileName, lineNumber: 218}}, candidate.Secondary)
    )
  )
})
MentionPickerRow.displayName = 'MentionPickerRow'

/* the expanding text input uses the techniques in this tutorial https://alistapart.com/article/expanding-text-areas-made-elegant. Basically,
* We maintain a <span> "mirror" which contains the content of the textarea. We then query the mirror to render the textarea dimensions. */
// Was a plain class component: no memo, so it re-renders with its parent as
// before. The DOM nodes are refs (set by stable callback refs, as the class
// fields were), and every handler keeps one identity for the component's
// life (EmojiPicker rebuilds its picker when `onSelect` changes), reading the
// latest props and state through `latest`, as the class read
// `this.props`/`this.state` when called.
const ExpandingInput = (props) => {
  const {
    disabled, value, className, maxLength, onAttachmentClick, ariaLabel,
    placeholder = 'Type your message...',
    variant = 'simple', role = 'staff', statusLine, aboveField, hasAttachments, patientCount,
  } = props
  const isFull = variant === 'full'
  const mentionCandidates = props.mentionCandidates || EMPTY_CANDIDATES
  const mentions = props.mentions || EMPTY_MENTIONS
  const [showEmojiMart, setShowEmojiMart] = _react.useState.call(void 0, false)
  const [menuOpen, setMenuOpen] = _react.useState.call(void 0, false)
  const menuId = _react.useId.call(void 0, )
  // Gates set through the handle, by source; the prop is one more.
  const [handleGates, setHandleGates] = _react.useState({})
  const sendGate = _react.useMemo.call(void 0, 
    () => _composer.combineSendGates.call(void 0, [props.sendGate, ...Object.values(handleGates)]),
    [props.sendGate, handleGates],
  )
  const [mentionQuery, setMentionQuery] = _react.useState(null)
  const [mentionIndex, setMentionIndex] = _react.useState.call(void 0, 0)
  // The picker is placed from the caret during render. Moving the caret to
  // another `@` with the same query changes no state, so this forces the
  // render that re-places it, as the class's setState always re-rendered.
  const [, placeMentionPicker] = _react.useReducer.call(void 0, (n) => n + 1, 0)

  const container = _react.useRef(null)
  const mirror = _react.useRef(null)
  const input = _react.useRef(null)
  // The emoji button (simple) or the + button (full): the emoji picker's anchor.
  const emojiToggle = _react.useRef(null)
  // Full: + sits on the row below the text, so the picker anchors on a mark at
  // the card's top edge above +, and opens over the timeline, not the text.
  const emojiAnchor = _react.useRef(null)
  const rowEnd = _react.useRef(null)

  const latest = _react.useRef.call(void 0, { props, showEmojiMart, mentionQuery, mentionIndex, sendGate })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { props, showEmojiMart, mentionQuery, mentionIndex, sendGate }
  })

  // Full: one line, with + and Send ▾ beside the text, until the text needs a
  // second line or Shift+Enter is pressed. It then stays expanded (text above,
  // buttons below) for that draft, even if the text is deleted, until a send
  // or another draft. Holds the draft it expanded for.
  const draftKey = _nullishCoalesce(props.draftKey, () => ( ''))
  const [expandedFor, setExpandedFor] = _react.useState(null)
  // Another draft forgets the last one's state, so coming back to it starts
  // as one line too.
  const [shownDraft, setShownDraft] = _react.useState.call(void 0, draftKey)
  if (shownDraft !== draftKey) {
    setShownDraft(draftKey)
    setExpandedFor(null)
  }
  const expanded = expandedFor === draftKey
  const expandedRef = _react.useRef.call(void 0, expanded)
  _react.useLayoutEffect.call(void 0, () => { expandedRef.current = expanded })
  // The card as it was last painted, and, while a switch is pending, as it
  // was painted just before it: the animation starts from there. An event
  // handler reads the card itself, which is what is on screen; a layout
  // effect has already laid out the next commit, so it uses the snapshot.
  const painted = _react.useRef(null)
  const beforeSwitch = _react.useRef(null)
  const switchLayout = _react.useCallback.call(void 0, (next, fromScreen) => {
    const onScreen = fromScreen && container.current ? measureCard(container.current) : painted.current
    beforeSwitch.current = beforeSwitch.current || onScreen
    setExpandedFor(next)
  }, [])
  const expand = _react.useCallback.call(void 0, () => {
    if (!expandedRef.current) switchLayout(_nullishCoalesce(latest.current.props.draftKey, () => ( '')), false)
  }, [switchLayout])
  const collapse = _react.useCallback.call(void 0, () => {
    if (expandedRef.current) switchLayout(null, true)
  }, [switchLayout])

  // Draws the text into the mirror with mention pills and a zero-width marker
  // at the caret, which the picker uses to place itself.
  const renderMirror = _react.useCallback.call(void 0, (text, textMentions, chips = NO_CHIPS) => {
    const mirrorNode = mirror.current
    if (!mirrorNode) return
    mirrorNode.replaceChildren()
    const caret = input.current && document.activeElement === input.current ? input.current.selectionStart : -1
    let offset = 0
    let caretPlaced = false
    const appendCaret = () => {
      caretPlaced = true
      const marker = document.createElement('span')
      marker.className = 'composer-caret-marker'
      marker.textContent = '​'
      mirrorNode.appendChild(marker)
    }
    const appendSpan = (className, segmentText) => {
      const node = document.createElement('span')
      node.className = className
      node.textContent = segmentText
      mirrorNode.appendChild(node)
    }
    // `at` is where segmentText starts in the draft, so chips can be cut out.
    const append = (segmentText, pill, at) => {
      if (!segmentText) return
      if (pill) return appendSpan('composer-mention-pill', segmentText)
      let cursor = 0
      for (const chip of chips) {
        const from = Math.max(chip.start - at, cursor)
        const to = Math.min(chip.end - at, segmentText.length)
        if (to <= from) continue
        if (from > cursor) mirrorNode.appendChild(document.createTextNode(segmentText.slice(cursor, from)))
        appendSpan(chip.flash ? 'composer-template-chip composer-template-chip--flash' : 'composer-template-chip', segmentText.slice(from, to))
        cursor = to
      }
      if (cursor < segmentText.length) mirrorNode.appendChild(document.createTextNode(segmentText.slice(cursor)))
    }
    _mentions.splitTextWithMentions.call(void 0, text, textMentions).forEach(segment => {
      const pill = !!segment.mention
      if (!caretPlaced && caret >= offset && caret <= offset + segment.text.length) {
        append(segment.text.slice(0, caret - offset), pill, offset)
        appendCaret()
        append(segment.text.slice(caret - offset), pill, caret)
      } else {
        append(segment.text, pill, offset)
      }
      offset += segment.text.length
    })
    if (!caretPlaced && caret >= offset) appendCaret()
  }, [])

  // componentDidMount/componentDidUpdate: redraw the mirror on mount and
  // whenever the value or its mentions change.
  _react.useLayoutEffect.call(void 0, () => {
    renderMirror(value || '', mentions, props.chipRanges)
  }, [renderMirror, value, mentions, props.chipRanges])

  // One line: the text's right padding is what Send ▾ and the counter take,
  // so it gets all the width between the buttons; it expands once it wraps.
  const checkOneLine = _react.useCallback.call(void 0, () => {
    const card = container.current
    if (!card || !mirror.current || expandedRef.current) return
    if (rowEnd.current) card.style.setProperty('--composer-end-width', `${rowEnd.current.offsetWidth}px`)
    if ((latest.current.props.value || '').includes('\n') || lineCount(mirror.current) > 1) expand()
  }, [expand])
  _react.useLayoutEffect.call(void 0, () => {
    if (isFull) checkOneLine()
  })
  // A narrower window can wrap the line too.
  _react.useLayoutEffect.call(void 0, () => {
    if (!isFull || !container.current || typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(() => checkOneLine())
    observer.observe(container.current)
    return () => observer.disconnect()
  }, [isFull, checkOneLine])

  // The switch, in one pass: the card's height goes from what was painted to
  // its new height, and +, Send ▾ and the text slide from where they were
  // painted to their new places with it, so nothing jumps or hides behind the
  // card's edge. One layout read, in the first frame, then only animations.
  _react.useLayoutEffect.call(void 0, () => {
    const card = container.current
    const from = beforeSwitch.current
    beforeSwitch.current = null
    if (!card || !from || typeof card.animate !== 'function' || prefersReducedMotion()) return
    const parts = MOVING_PARTS.map(({ selector }) => card.querySelector(selector))
    for (const node of [card, ...parts]) _optionalChain([node, 'optionalAccess', _8 => _8.getAnimations, 'optionalCall', _9 => _9(), 'access', _10 => _10.forEach, 'call', _11 => _11(animation => animation.cancel())])
    const to = card.getBoundingClientRect().height
    const resize = card.animate(
      [{ height: `${from.height}px`, overflow: 'hidden' }, { height: `${to}px`, overflow: 'hidden' }],
      SWITCH_TIMING,
    )
    // Typing during the animation records it mid-way; record where it ends.
    resize.onfinish = () => {
      if (container.current && !beforeSwitch.current) painted.current = measureCard(container.current)
    }
    // A new animation applies from the next frame, so the parts are read there,
    // under the card's start height, and set moving before that frame paints.
    requestAnimationFrame(() => {
      if (resize.playState !== 'running') return
      const start = measureCard(card)
      parts.forEach((node, i) => {
        const was = from.parts[i]
        const now = start.parts[i]
        if (!node || !was || !now) return
        node.animate(
          [{ transform: `translate(${was.x - now.x}px, ${was.y - now.y}px)` }, { transform: 'translate(0, 0)' }],
          SWITCH_TIMING,
        )
      })
    })
  }, [expanded])

  // Leaving the composer goes back to one line when the text fits there: no
  // line break, and one line no wider than the space between + and Send ▾.
  // Focus moving to the composer's own controls (+, its menu, the emoji
  // picker, Send ▾, Send later) is not leaving it.
  const fitsOneLine = _react.useCallback.call(void 0, () => {
    const card = container.current
    const text = mirror.current
    if (!card || !text) return false
    if ((latest.current.props.value || '').includes('\n') || lineCount(text) > 1) return false
    const start = parseFloat(getComputedStyle(card).getPropertyValue('--composer-one-line-start')) || 0
    const end = parseFloat(card.style.getPropertyValue('--composer-end-width')) || 0
    const inner = card.getBoundingClientRect().width - (card.offsetWidth - card.clientWidth)
    return text.getBoundingClientRect().width <= inner - start - end
  }, [])
  const leave = _react.useCallback.call(void 0, () => {
    if (fitsOneLine()) collapse()
  }, [fitsOneLine, collapse])
  // Leaving is focus moving from any of the composer's surfaces (the card,
  // or the Send later panel beside it) to somewhere that is none of them. A
  // press on its own surface moves focus between press and release (a click
  // on its non-focusable parts leaves focus nowhere), so a blur in between is
  // not leaving it; tabbing never sets this. A press outside while focus is
  // in it is leaving it, judged before the press closes the panel: a focused
  // panel that unmounts takes its focus with it and reports no blur.
  const usingOwnControl = _react.useRef.call(void 0, false)
  _react.useEffect.call(void 0, () => {
    if (!isFull) return
    const onPress = (event) => {
      usingOwnControl.current = isComposerPart(event.target, container.current)
      if (!usingOwnControl.current && expandedRef.current && isComposerPart(document.activeElement, container.current)) leave()
    }
    const onRelease = () => { usingOwnControl.current = false }
    const onFocusOut = (event) => {
      if (!expandedRef.current || usingOwnControl.current) return
      const destination = event instanceof FocusEvent ? event.relatedTarget : null
      if (!isComposerPart(event.target, container.current) || isComposerPart(destination, container.current)) return
      leave()
    }
    const listeners = [
      ['pointerdown', onPress], ['mousedown', onPress], ['pointerup', onRelease], ['mouseup', onRelease], ['focusout', onFocusOut],
    ] 
    listeners.forEach(([type, listener]) => document.addEventListener(type, listener, true))
    return () => listeners.forEach(([type, listener]) => document.removeEventListener(type, listener, true))
  }, [isFull, leave])

  // Last: the card as this commit paints it.
  _react.useLayoutEffect.call(void 0, () => {
    if (isFull && container.current && !beforeSwitch.current) painted.current = measureCard(container.current)
  })

  const focus = _react.useCallback.call(void 0, () => {
    if (input.current) input.current.focus()
  }, [])

  // componentDidMount / componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => {
    const handleEsc = (event) => {
      if (event.keyCode === 27 && latest.current.showEmojiMart) {
        setShowEmojiMart(false)
        focus()
      }
    }
    window.addEventListener('keyup', handleEsc)
    return () => window.removeEventListener('keyup', handleEsc)
  }, [focus])

  const updateMentionQuery = _react.useCallback.call(void 0, (text) => {
    if (!input.current || input.current !== document.activeElement) return
    const before = text.slice(0, input.current.selectionStart)
    const match = before.match(/(?:^|\s)@([^\s@]*)$/u)
    const query = match ? (match[1] || '') : null
    if (query !== null && _optionalChain([latest, 'access', _12 => _12.current, 'access', _13 => _13.props, 'access', _14 => _14.mentionCandidates, 'optionalAccess', _15 => _15.length])) {
      setMentionQuery(query)
      setMentionIndex(0)
      placeMentionPicker()
    } else if (latest.current.mentionQuery !== null) {
      setMentionQuery(null)
      setMentionIndex(0)
    }
  }, [])

  const updateValue = _react.useCallback.call(void 0, (text, mentionsOverride) => {
    const { onChange, onMentionsChange, value: previousValue, mentions: previousMentions } = latest.current.props

    const processedText = processEmojis(text)
    const delta = text.length - processedText.length

    if (delta && input.current && input.current === document.activeElement) {
      const start = input.current.selectionStart - delta
      const end = input.current.selectionEnd - delta
      requestAnimationFrame(() => _optionalChain([input, 'access', _16 => _16.current, 'optionalAccess', _17 => _17.setSelectionRange, 'optionalCall', _18 => _18(start, end)]))
    }

    // The edit ends at the caret, so it starts no later than the caret minus
    // what the edit added. Emoji replacement moves text, so skip the hint then.
    const editStart = !delta && input.current
      ? input.current.selectionStart - Math.max(0, processedText.length - (previousValue || '').length)
      : undefined
    onChange(null, processedText)
    _optionalChain([onMentionsChange, 'optionalCall', _19 => _19(mentionsOverride || _mentions.reconcileMentions.call(void 0, previousValue || '', processedText, previousMentions || [], editStart))])
    updateMentionQuery(processedText)
  }, [updateMentionQuery])

  const clear = _react.useCallback.call(void 0, () => updateValue(''), [updateValue])

  // Mirrors mobile's composer guard. The send control renders unconditionally
  // (it replaced a thumbs-up quick-send that was only shown while the input was
  // empty), so without this a scripted click on an untouched composer -- which
  // is what an email-security link scanner does to the anonymous patient chat --
  // posts a blank message attributed to the recipient.
  const onSend = _react.useCallback.call(void 0, () => {
    // Read the live textarea when it exists: it is the same string as
    // props.value in controlled use, and it is the value a scripted click
    // actually sees.
    const { props: { hasAttachments: hasFiles, value: currentValue }, sendGate: gate } = latest.current
    if (gate.blocked) {
      _optionalChain([gate, 'access', _20 => _20.onBlockedSend, 'optionalCall', _21 => _21()])
      return
    }
    if (!hasFiles && _string.isBlank.call(void 0, input.current ? input.current.value : currentValue)) return

    latest.current.props.onSend()
    collapse()
    if (!latest.current.props.keepDraftOnSend) clear()
  }, [clear, collapse])

  const selectMention = _react.useCallback.call(void 0, (candidate) => {
    const { props: current, mentionQuery: query } = latest.current
    if (!input.current || query === null) return
    const currentValue = current.value || ''
    const cursor = input.current.selectionStart
    const start = cursor - query.length - 1
    const inserted = `@${candidate.DisplayName} `
    const next = currentValue.slice(0, start) + inserted + currentValue.slice(cursor)
    const delta = inserted.length - (cursor - start)
    const kept = (current.mentions || [])
      .filter(m => m.End <= start || m.Start >= cursor)
      .map(m => m.Start >= cursor ? { ...m, Start: m.Start + delta, End: m.End + delta } : m)
    // Write the text and caret now: React re-renders with the same value and
    // leaves the caret alone, so a key pressed right after the pick lands after
    // the pill instead of at the end of the message.
    const position = start + inserted.length
    input.current.value = next
    input.current.setSelectionRange(position, position)
    updateValue(next, [...kept, _mentions.mentionText.call(void 0, candidate, start)].sort((a, b) => a.Start - b.Start))
    setMentionQuery(null)
    setMentionIndex(0)
  }, [updateValue])

  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.nativeEvent.isComposing || e.keyCode === 229) return
    if (_optionalChain([latest, 'access', _22 => _22.current, 'access', _23 => _23.props, 'access', _24 => _24.onKeyDownFirst, 'optionalCall', _25 => _25(e)])) return
    const { props: current, mentionQuery: query, mentionIndex: index } = latest.current
    // Only claim navigation keys while the picker is actually on screen; a
    // query with no matches renders nothing, so the keys keep their defaults.
    const options = query !== null
      ? _mentions.getVisibleMentionCandidates.call(void 0, current.mentionCandidates || [], query)
      : []
    if (options.length) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault()
        const offset = e.key === 'ArrowDown' ? 1 : -1
        setMentionIndex(Math.max(0, Math.min(options.length - 1, index + offset)))
        return
      }
      const selected = options[Math.min(index, options.length - 1)]
      if ((e.key === 'Enter' || e.key === 'Tab') && selected) {
        e.preventDefault()
        selectMention(selected)
        return
      }
      if (e.key === 'Escape') {
        e.preventDefault()
        setMentionQuery(null)
        return
      }
    }
    if (e.key === 'Enter' && !e.nativeEvent.shiftKey) {
      e.stopPropagation()
      e.preventDefault()

      onSend()
    }
    // Shift+Enter's line break expands the composer in the same commit as the
    // text, so the animation runs once, to the final height.
  }, [onSend, selectMention])

  const onSelect = _react.useCallback.call(void 0, (event) => {
    const target = event.currentTarget
    renderMirror(target.value, latest.current.props.mentions || [], latest.current.props.chipRanges)
    updateMentionQuery(target.value)
  }, [renderMirror, updateMentionQuery])

  const pasteFiles = _react.useCallback.call(void 0, (e) => {
    const files = e.clipboardData.files
    if (files && files.length > 0) latest.current.props.onPasteFiles(Array.from(files))
  }, [])

  const onInput = _react.useCallback.call(void 0, (e) => {
    e.preventDefault()
    if (!mirror.current || !container.current || !input.current) return
    const previous = latest.current.props.value || ''
    const text = (e.target ).value
    updateValue(text)
    const trigger = _composer.detectTypedTrigger.call(void 0, previous, text)
    if (trigger) _optionalChain([latest, 'access', _26 => _26.current, 'access', _27 => _27.props, 'access', _28 => _28.onTypedTrigger, 'optionalCall', _29 => _29(trigger)])
  }, [updateValue])

  const openEmojiMart = _react.useCallback.call(void 0, () => setShowEmojiMart(true), [])
  const closeEmojiMart = _react.useCallback.call(void 0, () => setShowEmojiMart(false), [])

  const placeCaret = _react.useCallback.call(void 0, (position) => {
    requestAnimationFrame(() => {
      if (!input.current) return
      input.current.focus()
      input.current.setSelectionRange(position, position)
    })
  }, [])

  // The draft API. Inserting writes over the selection, at the caret the
  // field kept when focus moved to a menu or picker.
  const insertAtCaret = _react.useCallback.call(void 0, (text) => {
    const { value: currentValue = '' } = latest.current.props
    const start = input.current ? input.current.selectionStart : currentValue.length
    const end = input.current ? input.current.selectionEnd : start
    const next = _composer.insertText.call(void 0, currentValue, start, end, text)
    updateValue(next.value)
    placeCaret(next.caret)
  }, [updateValue, placeCaret])

  const replaceDraft = _react.useCallback.call(void 0, (text, draftMentions) => {
    updateValue(text, draftMentions ? [...draftMentions] : EMPTY_MENTIONS)
    placeCaret(text.length)
  }, [updateValue, placeCaret])

  const setSendGate = _react.useCallback.call(void 0, (source, gate) => {
    setHandleGates(current => {
      const next = { ...current }
      if (gate) next[source] = gate
      else delete next[source]
      return next
    })
  }, [])

  const getSelection = _react.useCallback.call(void 0, () => {
    const length = (latest.current.props.value || '').length
    return input.current
      ? { start: input.current.selectionStart, end: input.current.selectionEnd }
      : { start: length, end: length }
  }, [])

  const select = _react.useCallback.call(void 0, ({ start, end }) => {
    requestAnimationFrame(() => {
      if (!input.current) return
      input.current.focus()
      input.current.setSelectionRange(start, end)
    })
  }, [])

  _react.useImperativeHandle.call(void 0, 
    props.ref,
    () => ({ insertAtCaret, replaceDraft, focus, setSendGate, getSelection, select }),
    [insertAtCaret, replaceDraft, focus, setSendGate, getSelection, select],
  )

  const emojiSelect = _react.useCallback.call(void 0, (emoji) => {
    closeEmojiMart()
    insertAtCaret(emoji)
  }, [closeEmojiMart, insertAtCaret])

  const setContainerRef = _react.useCallback.call(void 0, (ref) => { container.current = ref }, [])
  const setMirrorRef = _react.useCallback.call(void 0, (ref) => { mirror.current = ref }, [])
  const setInputRef = _react.useCallback.call(void 0, (ref) => { input.current = ref }, [])
  const setEmojiToggleRef = _react.useCallback.call(void 0, (ref) => { emojiToggle.current = ref }, [])

  // The + menu and its shortcuts, from the shared registry.
  const ctx = _react.useMemo.call(void 0, () => ({
    platform: composerPlatform(),
    channel: _optionalChain([statusLine, 'optionalAccess', _30 => _30.channel]) || 'secure',
    role,
    disabled: !!disabled,
    hasText: !_string.isBlank.call(void 0, value || ''),
    hasFiles: !!hasAttachments,
    textLength: (value || '').length,
    sendGate,
    patientCount,
  }), [_optionalChain([statusLine, 'optionalAccess', _31 => _31.channel]), role, disabled, value, hasAttachments, sendGate, patientCount])
  const mac = _react.useMemo.call(void 0, isMac, [])

  const runSendLater = _react.useCallback.call(void 0, () => {
    const gate = latest.current.sendGate
    if (gate.blocked) {
      _optionalChain([gate, 'access', _32 => _32.onBlockedSend, 'optionalCall', _33 => _33()])
      return
    }
    const { menuActions: shown, ctx: context } = latestMenu.current
    const schedule = shown.find(action => action.id === 'schedule')
    if (!schedule || !_composer.composerActionState.call(void 0, schedule, context).enabled) return
    _optionalChain([latest, 'access', _34 => _34.current, 'access', _35 => _35.props, 'access', _36 => _36.onSendLater, 'optionalCall', _37 => _37()])
  }, [])

  const extraHandlers = props.actionHandlers || NO_HANDLERS
  const handlers = _react.useMemo.call(void 0, () => ({
    ...extraHandlers,
    attach: onAttachmentClick,
    emoji: openEmojiMart,
    ...(props.onSendLater ? { schedule: runSendLater } : {}),
  }), [extraHandlers, onAttachmentClick, openEmojiMart, props.onSendLater, runSendLater])

  const menuActions = _react.useMemo.call(void 0, 
    () => isFull ? _composer.getComposerActions.call(void 0, ctx).filter(action => handlers[action.id]) : [],
    [isFull, ctx, handlers],
  )
  const scheduleAction = menuActions.find(action => action.id === 'schedule')
  const showSendLater = !!scheduleAction
  // Schedule has its own button next to Send on web, so the + menu leaves it out.
  const plusMenuActions = _react.useMemo.call(void 0, 
    () => menuActions.filter(action => action.id !== 'schedule'),
    [menuActions],
  )
  const sendLaterState = _react.useMemo.call(void 0, 
    () => scheduleAction ? _composer.composerActionState.call(void 0, scheduleAction, ctx) : undefined,
    [scheduleAction, ctx],
  )

  const latestMenu = _react.useRef.call(void 0, { menuActions, handlers, ctx })
  _react.useLayoutEffect.call(void 0, () => {
    latestMenu.current = { menuActions, handlers, ctx }
  })

  const closeMenu = _react.useCallback.call(void 0, () => setMenuOpen(false), [])
  const closeMenuToField = _react.useCallback.call(void 0, () => {
    setMenuOpen(false)
    focus()
  }, [focus])
  const toggleMenu = _react.useCallback.call(void 0, () => setMenuOpen(open => !open), [])

  const runAction = _react.useCallback.call(void 0, (action) => {
    setMenuOpen(false)
    focus()
    _optionalChain([latestMenu, 'access', _38 => _38.current, 'access', _39 => _39.handlers, 'access', _40 => _40[action.id], 'optionalCall', _41 => _41()])
  }, [focus])

  // Shortcuts work anywhere in the composer, and only there.
  const onComposerKeyDown = _react.useCallback.call(void 0, (e) => {
    if (e.nativeEvent.isComposing) return
    const { menuActions: shown, ctx: context } = latestMenu.current
    if (_composer.matchesShortcut.call(void 0, e, _composer.MENU_SHORTCUT, mac)) {
      e.preventDefault()
      if (!context.disabled) setMenuOpen(open => !open)
      return
    }
    const action = shown.find(candidate => candidate.shortcut && _composer.matchesShortcut.call(void 0, e, candidate.shortcut, mac))
    if (!action) return
    e.preventDefault()
    if (_composer.composerActionState.call(void 0, action, context).enabled) runAction(action)
  }, [mac, runAction])

  // The class read `this.emojiToggle` in render: null on the first render, so
  // the picker's tooltip mounts from the next render on. Reading the ref here
  // keeps that timing.
  const emojiToggleNode = emojiToggle.current
  const emojiTarget = isFull ? emojiAnchor.current : emojiToggleNode

  const mentionOptions = mentionQuery !== null
    ? _mentions.getVisibleMentionCandidates.call(void 0, mentionCandidates, mentionQuery)
    : EMPTY_CANDIDATES

  // Placed from the caret marker the mirror draws, read during render as the
  // class did.
  const mentionPickerStyle = () => {
    if (!input.current || !container.current) return {}
    const containerRect = container.current.getBoundingClientRect()
    const marker = _optionalChain([mirror, 'access', _42 => _42.current, 'optionalAccess', _43 => _43.querySelector, 'call', _44 => _44('.composer-caret-marker')]) 
    const inputRect = input.current.getBoundingClientRect()
    const markerRect = _optionalChain([marker, 'optionalAccess', _45 => _45.getBoundingClientRect, 'call', _46 => _46()])
    const rawLeft = markerRect ? markerRect.left - containerRect.left : inputRect.left - containerRect.left
    const maxLeft = Math.max(8, containerRect.width - 390)
    const left = Math.max(8, Math.min(rawLeft, maxLeft))

    // Keep the surface tied to the caret's line. In a multiline composer the
    // marker's top can move while the composer height stays fixed; using the
    // old fixed bottom value made the picker appear beside a different line.
    // Prefer above-caret placement (the approved surface), falling below only
    // when the caret is near the top of the viewport.
    const caretTop = _nullishCoalesce(_optionalChain([markerRect, 'optionalAccess', _47 => _47.top]), () => ( inputRect.top))
    const caretBottom = _nullishCoalesce(_optionalChain([markerRect, 'optionalAccess', _48 => _48.bottom]), () => ( inputRect.bottom))
    const viewportHeight = typeof window === 'undefined' ? containerRect.bottom : window.innerHeight
    const above = Math.max(0, caretTop - 8)
    const below = Math.max(0, viewportHeight - caretBottom - 8)
    const placeAbove = above >= 120 || above >= below
    const maxHeight = Math.min(400, Math.max(1, placeAbove ? above : below))
    if (placeAbove) {
      return {
        left,
        bottom: Math.max(8, containerRect.bottom - caretTop + 4),
        maxHeight,
      }
    }
    return { left, top: Math.max(8, caretBottom - containerRect.top + 4), maxHeight }
  }

  // A plain SMS past one text goes as several (smsParts); the counter says so.
  const counter = !isFull
    ? null
    : _optionalChain([statusLine, 'optionalAccess', _49 => _49.channel]) === 'sms'
      ? _composer.smsCounter.call(void 0, value || '')
      : _composer.lengthCounter.call(void 0, (value || '').length, maxLength)

  const field = (
    _react2.default.createElement('div', {
      ref: setContainerRef,
      style: disabled ? containerStyle : undefined,
      className: _classBuilder2.default.call(void 0, 
        "chat--createMessageBox--inputarea",
        isFull && "chat--createMessageBox--inputarea--full",
        isFull && !expanded && "chat--createMessageBox--inputarea--collapsed",
        className,
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 829}}

      /* + comes first in the DOM, as it is drawn left of the field, so Tab
          goes + → field → Send. */
      , isFull && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('button', {
            ref: setEmojiToggleRef,
            type: "button",
            className: "chat--createMessageBox--inputarea--plus",
            'aria-label': "More actions" ,
            'aria-haspopup': "menu",
            'aria-expanded': menuOpen,
            'aria-controls': menuOpen ? menuId : undefined,
            disabled: disabled,
            onClick: toggleMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 843}}

            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 854}}, menuOpen ? 'close' : 'add')
          )
          , _react2.default.createElement('span', { ref: emojiAnchor, className: "composer-emoji-anchor", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 856}} )
          , menuOpen && !disabled && (
            _react2.default.createElement(_ComposerActionMenu2.default, {
              id: menuId,
              actions: plusMenuActions,
              ctx: ctx,
              mac: mac,
              anchor: emojiToggleNode,
              onPick: runAction,
              onEscape: closeMenuToField,
              onDismiss: closeMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 858}}
            )
          )
        )
      )
      , _react2.default.createElement('pre', { className: "chat--createMessageBox--mirror-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 871}}
        , _react2.default.createElement('span', {
          ref: setMirrorRef,
          className: "chat--createMessageBox--mirror", __self: this, __source: {fileName: _jsxFileName, lineNumber: 872}}
        )
        , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 876}})
      )
      , _react2.default.createElement('textarea', {
        id: "main-input",
        className: 'chat--createMessageBox--input',
        'data-gramm': false,
        value: value,
        onChange: noop,
        onInput: onInput,
        onSelect: onSelect,
        placeholder: placeholder,
        'aria-label': ariaLabel,
        maxLength: maxLength,
        ref: setInputRef,
        onKeyDown: onKeyDown,
        onPaste: pasteFiles,
        autoFocus: true,
        spellCheck: true,
        rows: 1,
        disabled: disabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 878}}
      )
      /* One combined list: the avatar (initials, team icon, @) already tells people and teams apart. */
      , mentionQuery !== null && mentionOptions.length > 0 && (
        _react2.default.createElement('div', { className: "chat--mention-picker", role: "listbox", 'aria-label': "Mention suggestions" , style: mentionPickerStyle(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 899}}
          , mentionOptions.map((candidate, index) => (
            _react2.default.createElement(MentionPickerRow, {
              key: `${candidate.Kind}:${candidate.TargetKey || candidate.DisplayName}`,
              candidate: candidate,
              index: index,
              query: mentionQuery,
              selected: index === mentionIndex,
              onPick: selectMention,
              onHover: setMentionIndex, __self: this, __source: {fileName: _jsxFileName, lineNumber: 901}}
            )
          ))
        )
      )
      ,  emojiToggleNode && (
        _react2.default.createElement(_Tooltip.ControlledTooltip, {
          isOpen: showEmojiMart,
          place: "top",
          onClose: closeEmojiMart,
          domTarget: emojiTarget,
          content: _react2.default.createElement(_EmojiPicker2.default, { onSelect: disabled ? null : emojiSelect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 919}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 914}}
        )
      )
      , isFull ? (
        // The row below the text: the counter sits just left of Send ▾.
        _react2.default.createElement('div', { ref: rowEnd, className: "composer-row-end", __self: this, __source: {fileName: _jsxFileName, lineNumber: 924}}
          , counter && (
            _react2.default.createElement('span', { className: "composer--counter", __self: this, __source: {fileName: _jsxFileName, lineNumber: 926}}
              , _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 927}}, counter.text)
              , _react2.default.createElement('span', { className: "composer--sr-only", __self: this, __source: {fileName: _jsxFileName, lineNumber: 928}}, counter.label)
            )
          )
          , _react2.default.createElement(_ComposerSendButton2.default, {
            disabled: !!disabled,
            gate: sendGate,
            isEmpty: !ctx.hasText && !hasAttachments,
            showSendLater: showSendLater,
            sendLaterState: sendLaterState,
            label: props.sendLabel,
            onSend: onSend,
            onSendLater: runSendLater, __self: this, __source: {fileName: _jsxFileName, lineNumber: 931}}
          )
        )
      ) : (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('button', {
            type: "button",
            className: "chat--createMessageBox--inputarea--attach",
            'aria-label': "Attach files" ,
            disabled: disabled,
            onClick: onAttachmentClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 944}}

            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 951}}, "attach_file")
          )
          , _react2.default.createElement('button', {
            ref: setEmojiToggleRef,
            type: "button",
            className: "chat--createMessageBox--inputarea--emoji",
            'aria-label': "Emoji",
            disabled: disabled,
            onClick: openEmojiMart, __self: this, __source: {fileName: _jsxFileName, lineNumber: 953}}

            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 961}}, "insert_emoticon")
          )
          , _react2.default.createElement('button', {
            type: "button",
            className: "chat--createMessageBox--inputarea--send-button",
            'aria-label': "Send",
            disabled: disabled,
            onClick: onSend, __self: this, __source: {fileName: _jsxFileName, lineNumber: 963}}

            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 970}}, "send")
          )
        )
      )
    )
  )

  if (!isFull) return field

  return (
    _react2.default.createElement('div', { className: "composer", onKeyDown: onComposerKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 980}}
      , aboveField
      , field
    )
  )
}

exports. default = ExpandingInput
